import { TagCategory } from './tag-category';

export class Tag {
	public id: number;
	public name: string;
	public parentId: number;
	public tagCategoryId: number;
	public userId: string;
	public modifiedUserId: string;
	public addDate: string;
	public modifiedDate: string;
	public parent: Tag;
	public children: Tag[];
	public tagCategory: TagCategory;

	constructor(tag: Tag) {
		Object.assign(this, tag);

		this.parent = tag.parent ? new Tag(tag.parent) : tag.parent;
		this.children = tag.children ? tag.children.map((c: Tag) => new Tag(c)) : tag.children;
		this.tagCategory = tag.tagCategory ? new TagCategory(tag.tagCategory) : tag.tagCategory;
	}
}
